import React from 'react'
import PropTypes from 'prop-types'

import ActiveMembershipProvider from './ActiveMembershipStore'
import SubscriptionStates from './SubscriptionStates'

const ActiveMembership = ({ handleError }) => {
  return (
    <ActiveMembershipProvider handleError={handleError}>
      <SubscriptionStates />
    </ActiveMembershipProvider>
  )
}

ActiveMembership.propTypes = {
  handleError: PropTypes.func.isRequired
}

export default ActiveMembership
